export enum SegmentTypeEnum {
  EntireEntity = 1,
  ProductLine,
  ProductLineGroup,
  Division,
  SubDivision,
  Group,
  SubGroup,
  Other,
}
